// Temporarily off: the merchant's SMS OTP delivery (personal SIM in a
// tablet, see supabase/functions/send-otp) isn't usable right now, and
// order confirmation is being handled via FlashManager's WhatsApp
// confirmation flow instead. Flip back to true once a real SMS gateway (or
// the SIM) is sorted out - create-order/index.ts has the matching
// REQUIRE_OTP secret that must be flipped back in the same change, since
// the server is the one actually enforcing this, not this flag.
const OTP_ENABLED = false;

class CodCartCheckout extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.messageEl = this.querySelector('.cod-cart-checkout__message');
    this.submitButton = this.querySelector('.cod-cart-checkout__submit');
    this.stickyCta = this.querySelector('.cod-cart-checkout__sticky-cta');
    this.wilayaSelect = this.querySelector('select[name="wilaya"]');
    this.communeSelect = this.querySelector('select[name="commune"]');
    this.deliveryModeSelect = this.querySelector('select[name="delivery_mode"]');
    this.shippingFeeEl = this.querySelector('.cod-cart-checkout__shipping-fee');
    this.grandTotalEl = this.querySelector('.cod-cart-checkout__grand-total');
    this.otpSection = this.querySelector('.cod-cart-checkout__otp');
    this.otpInput = this.querySelector('input[name="otp_code"]');
    this.resendButton = this.querySelector('.cod-cart-checkout__resend-otp');
    this.currentShippingFee = null;
    this.otpSent = false;
    this.verifiedPhone = null;

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.wilayaSelect.addEventListener('change', this.handleWilayaChange.bind(this));
    this.deliveryModeSelect.addEventListener('change', this.updateShippingSummary.bind(this));
    this.resendButton.addEventListener('click', this.handleResendOtp.bind(this));
    this.watchScrollPosition();

    this.regionButtons = this.querySelectorAll('.cod-cart-checkout__region-btn');
    this.domesticSection = this.querySelector('.cod-cart-checkout__domestic');
    this.internationalSection = this.querySelector('.cod-cart-checkout__international');
    this.intlForm = this.querySelector('.cod-cart-checkout__intl-form');
    this.intlMessageEl = this.querySelector('.cod-cart-checkout__intl-message');
    this.intlSubmitButton = this.intlForm.querySelector('.cod-cart-checkout__submit');
    this.regionManuallySet = false;

    this.regionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.regionManuallySet = true;
        this.setRegion(btn.dataset.region);
      });
    });
    this.intlForm.addEventListener('submit', this.handleIntlSubmit.bind(this));

    if (window.LoubnaRegionDetect) {
      window.LoubnaRegionDetect.detect(this.dataset.supabaseUrl).then((region) => {
        if (!this.regionManuallySet) this.setRegion(region);
      });
    }

    this.handleStripeReturn();
  }

  handleStripeReturn() {
    const params = new URLSearchParams(window.location.search);
    const stripeStatus = params.get('stripe');
    if (!stripeStatus) return;

    this.regionManuallySet = true;
    this.setRegion('intl');
    if (stripeStatus === 'success') {
      this.internationalSection.hidden = false;
      this.intlForm.hidden = true;
      this.showIntlMessage('success', this.dataset.stripeSuccessMessage);
    } else if (stripeStatus === 'cancelled') {
      this.showIntlMessage('error', this.dataset.stripeCancelledMessage);
    }
  }

  setRegion(region) {
    this.regionButtons.forEach((btn) => btn.classList.toggle('is-active', btn.dataset.region === region));
    this.domesticSection.hidden = region !== 'dz';
    this.internationalSection.hidden = region === 'dz';
  }

  handleWilayaChange() {
    if (this.otpSent) return;
    const wilayaCode = this.wilayaSelect.value.split(' - ')[0];
    const communes = (window.ALGERIA_COMMUNES || {})[wilayaCode] || [];
    this.communeSelect.innerHTML = '';

    const communePlaceholder = document.createElement('option');
    communePlaceholder.value = '';
    communePlaceholder.disabled = true;
    communePlaceholder.selected = true;
    communePlaceholder.textContent = this.dataset.chooseLabel;
    this.communeSelect.appendChild(communePlaceholder);

    for (const commune of communes) {
      const option = document.createElement('option');
      option.value = commune;
      option.textContent = commune;
      this.communeSelect.appendChild(option);
    }
    this.communeSelect.disabled = communes.length === 0;

    const rates = (window.ALGERIA_SHIPPING_RATES || {})[wilayaCode];
    this.deliveryModeSelect.innerHTML = '';

    const modePlaceholder = document.createElement('option');
    modePlaceholder.value = '';
    modePlaceholder.disabled = true;
    modePlaceholder.selected = true;
    modePlaceholder.textContent = this.dataset.chooseLabel;
    this.deliveryModeSelect.appendChild(modePlaceholder);

    if (rates) {
      const homeOption = document.createElement('option');
      homeOption.value = 'domicile';
      homeOption.dataset.fee = rates.domicile;
      homeOption.textContent = `${this.dataset.deliveryModeHomeLabel} — ${rates.domicile} DA`;
      this.deliveryModeSelect.appendChild(homeOption);

      const stopdeskOption = document.createElement('option');
      stopdeskOption.value = 'stopdesk';
      stopdeskOption.dataset.fee = rates.stopdesk;
      stopdeskOption.textContent = `${this.dataset.deliveryModeStopdeskLabel} — ${rates.stopdesk} DA`;
      this.deliveryModeSelect.appendChild(stopdeskOption);
    }

    this.deliveryModeSelect.disabled = !rates;
    this.updateShippingSummary();
  }

  updateShippingSummary() {
    const selectedOption = this.deliveryModeSelect.selectedOptions[0];
    const fee = selectedOption && selectedOption.dataset.fee ? Number(selectedOption.dataset.fee) : null;
    this.currentShippingFee = fee;

    let cart;
    try {
      cart = JSON.parse(this.querySelector('[data-cart-json]').textContent);
    } catch (error) {
      cart = null;
    }
    const itemsTotal = cart ? cart.total_price / 100 : 0;
    this.shippingFeeEl.textContent = fee === null ? '—' : `${fee} DA`;
    this.grandTotalEl.textContent = fee === null ? '—' : `${itemsTotal + fee} DA`;
  }

  watchScrollPosition() {
    if (!this.stickyCta) return;
    const target = this.querySelector('.cod-cart-checkout__heading');
    const updateState = () => {
      const hasReachedForm = target.getBoundingClientRect().top <= window.innerHeight;
      this.stickyCta.classList.toggle('is-settled', hasReachedForm);
    };
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateState();
        ticking = false;
      });
    });
    updateState();
  }

  getFunctionsUrl() {
    return this.dataset.supabaseUrl.replace('.supabase.co', '.supabase.co/functions/v1');
  }

  createRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
  }

  getCodRequestContext(cart, formData, customerPhone) {
    const signature = JSON.stringify({
      items: (cart.items || []).map((item) => [Number(item.variant_id), Number(item.quantity)]).sort((a, b) => a[0] - b[0]),
      customer_name: String(formData.get('customer_name') || '').trim(),
      customer_phone: customerPhone,
      wilaya: String(formData.get('wilaya') || ''),
      commune: String(formData.get('commune') || ''),
      delivery_mode: String(formData.get('delivery_mode') || ''),
      address: String(formData.get('address') || '').trim(),
      note: String(formData.get('note') || '').trim(),
    });
    let hash = 2166136261;
    for (let i = 0; i < signature.length; i += 1) {
      hash ^= signature.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    const fingerprint = `${(hash >>> 0).toString(16)}:${signature.length}`;
    const storageKey = 'loubna_cod_request_v1';
    try {
      const stored = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (stored && stored.fingerprint === fingerprint && /^[0-9a-f-]{36}$/i.test(stored.requestId || '')) {
        return { storageKey, requestId: stored.requestId };
      }
    } catch (_) {}
    const requestId = this.createRequestId();
    try { sessionStorage.setItem(storageKey, JSON.stringify({ fingerprint, requestId })); } catch (_) {}
    return { storageKey, requestId };
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (this.form.querySelector('[name="website"]').value) return;

    const supabaseUrl = this.dataset.supabaseUrl;
    const supabaseAnonKey = this.dataset.supabaseAnonKey;
    if (!supabaseUrl || !supabaseAnonKey) {
      this.showMessage('error', this.dataset.errorMessage);
      return;
    }

    const formData = new FormData(this.form);
    const customerPhone = normalizeAlgerianPhone(formData.get('customer_phone'));
    if (!customerPhone) {
      this.showMessage('error', this.dataset.errorMessage);
      return;
    }

    let otpCode = null;
    if (OTP_ENABLED) {
      if (!this.otpSent) {
        await this.requestOtp(customerPhone);
        return;
      }
      if (customerPhone !== this.verifiedPhone) {
        this.showMessage('error', this.dataset.invalidOtpMessage);
        return;
      }
      otpCode = (formData.get('otp_code') || '').trim();
      if (!otpCode) {
        this.showMessage('error', this.dataset.invalidOtpMessage);
        return;
      }
    }

    let cart;
    try {
      cart = JSON.parse(this.querySelector('[data-cart-json]').textContent);
    } catch (error) {
      this.showMessage('error', this.dataset.errorMessage);
      return;
    }
    if (!cart.items || cart.items.length === 0) {
      this.showMessage('error', this.dataset.errorMessage);
      return;
    }

    const items = cart.items.map((item) => ({ title: item.product_title, quantity: item.quantity }));
    const cartItems = cart.items.map((item) => ({ variant_id: item.variant_id, quantity: item.quantity }));
    const totalQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
    if (this.currentShippingFee === null) {
      this.showMessage('error', this.dataset.errorMessage);
      return;
    }

    const itemsTotal = cart.total_price / 100;
    const requestContext = this.getCodRequestContext(cart, formData, customerPhone);
    const payload = {
      request_id: requestContext.requestId,
      items,
      cart_items: cartItems,
      total_quantity: totalQuantity,
      total_price: itemsTotal,
      delivery_mode: formData.get('delivery_mode'),
      shipping_fee: this.currentShippingFee,
      grand_total: itemsTotal + this.currentShippingFee,
      customer_name: formData.get('customer_name'),
      customer_phone: customerPhone,
      wilaya: formData.get('wilaya'),
      commune: formData.get('commune'),
      address: formData.get('address') || null,
      note: formData.get('note') || null,
      otp_code: otpCode,
    };

    this.setLoading(true);
    try {
      const response = await fetch(`${this.getFunctionsUrl()}/create-order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: supabaseAnonKey,
          Authorization: `Bearer ${supabaseAnonKey}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        if (body.message === 'too_many_orders_from_phone') {
          this.showMessage('error', this.dataset.rateLimitMessage);
          return;
        }
        if (body.message === 'invalid_otp') {
          this.showMessage('error', this.dataset.invalidOtpMessage);
          return;
        }
        if (body.message === 'otp_expired') {
          this.showMessage('error', this.dataset.otpExpiredMessage);
          return;
        }
        throw new Error(`Request failed: ${response.status}`);
      }

      const responseData = await response.json().catch(() => ({}));
      await fetch('/cart/clear.js', { method: 'POST' });
      try { sessionStorage.removeItem(requestContext.storageKey); } catch (_) {}

      this.showMessage('success', this.dataset.successMessage);
      if (responseData.order_id) this.renderEmailCapturePrompt(responseData.order_id);
      this.renderReviewPrompt(cart.items);
      this.form.reset();
      this.form.hidden = true;
      if (this.stickyCta) this.stickyCta.hidden = true;
      requestAnimationFrame(() => this.messageEl.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    } catch (error) {
      this.showMessage('error', this.dataset.errorMessage);
    } finally {
      this.setLoading(false);
    }
  }

  async requestOtp(customerPhone) {
    const supabaseAnonKey = this.dataset.supabaseAnonKey;
    this.setLoading(true);
    try {
      const response = await fetch(`${this.getFunctionsUrl()}/send-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: supabaseAnonKey, Authorization: `Bearer ${supabaseAnonKey}` },
        body: JSON.stringify({ phone: customerPhone }),
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        if (body.message === 'too_many_otp_requests') {
          this.showMessage('error', this.dataset.otpRateLimitMessage);
          return;
        }
        throw new Error(`Request failed: ${response.status}`);
      }
      this.otpSent = true;
      this.verifiedPhone = customerPhone;
      this.lockFormForOtp();
      this.otpSection.hidden = false;
      this.otpInput.focus();
      this.submitButton.textContent = this.dataset.buttonLabel;
      this.showMessage('success', this.dataset.otpSentMessage);
      this.startResendCooldown();
    } catch (error) {
      this.showMessage('error', this.dataset.errorMessage);
    } finally {
      this.setLoading(false);
    }
  }

  async handleResendOtp() {
    if (this.resendButton.disabled) return;
    const formData = new FormData(this.form);
    const customerPhone = normalizeAlgerianPhone(formData.get('customer_phone'));
    if (!customerPhone) return;
    await this.requestOtp(customerPhone);
  }

  startResendCooldown() {
    const originalLabel = this.resendButton.textContent;
    let seconds = 60;
    this.resendButton.disabled = true;
    const tick = () => {
      this.resendButton.textContent = `${originalLabel} (${seconds}s)`;
      seconds -= 1;
      if (seconds < 0) {
        clearInterval(interval);
        this.resendButton.textContent = originalLabel;
        this.resendButton.disabled = false;
      }
    };
    tick();
    const interval = setInterval(tick, 1000);
  }

  lockFormForOtp() {
    this.form.querySelectorAll('input, select, textarea').forEach((field) => {
      if (field.name === 'otp_code' || field.name === 'website') return;
      field.classList.add('is-locked');
      if ('readOnly' in field) field.readOnly = true;
    });
  }

  setLoading(isLoading) {
    this.submitButton.disabled = isLoading;
  }

  showMessage(type, text) {
    this.messageEl.textContent = text;
    this.messageEl.className = `cod-cart-checkout__message cod-cart-checkout__message--${type}`;
  }

  async handleIntlSubmit(event) {
    event.preventDefault();
    if (this.intlForm.querySelector('[name="website"]').value) return;
    const supabaseAnonKey = this.dataset.supabaseAnonKey;
    let cart;
    try { cart = JSON.parse(this.querySelector('[data-cart-json]').textContent); } catch (error) { cart = null; }
    if (!cart || !cart.items || cart.items.length === 0) {
      this.showIntlMessage('error', this.dataset.errorMessage);
      return;
    }
    const formData = new FormData(this.intlForm);
    const cartItems = cart.items.map((item) => ({ variant_id: item.variant_id, title: item.product_title, quantity: item.quantity, price: item.price / 100 }));
    const payload = {
      type: 'physical',
      cart_items: cartItems,
      customer_name: formData.get('customer_name'),
      customer_email: formData.get('customer_email'),
      return_url: window.location.href.split('?')[0],
    };
    this.intlSubmitButton.disabled = true;
    try {
      const response = await fetch(`${this.getFunctionsUrl()}/create-stripe-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: supabaseAnonKey, Authorization: `Bearer ${supabaseAnonKey}` },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      const body = await response.json();
      if (!body.url) throw new Error('missing_checkout_url');
      window.location.href = body.url;
    } catch (error) {
      this.showIntlMessage('error', this.dataset.errorMessage);
      this.intlSubmitButton.disabled = false;
    }
  }

  showIntlMessage(type, text) {
    this.intlMessageEl.textContent = text;
    this.intlMessageEl.className = `cod-cart-checkout__message cod-cart-checkout__intl-message cod-cart-checkout__message--${type}`;
  }

  renderReviewPrompt(items) {
    if (!items || !items.length) return;
    const isAr = document.documentElement.getAttribute('dir') === 'rtl';
    const wrap = document.createElement('div');
    wrap.className = 'cod-cart-checkout__review-prompt';
    const heading = document.createElement('p');
    heading.textContent = isAr ? 'أخبرنا برأيك في كتبك:' : 'Rate the books you just ordered:';
    wrap.appendChild(heading);
    const list = document.createElement('div');
    list.className = 'cod-cart-checkout__review-links';
    items.forEach((item) => {
      const link = document.createElement('a');
      link.href = '/pages/leave-review?handle=' + encodeURIComponent(item.handle || '') + '&title=' + encodeURIComponent(item.product_title || '');
      link.textContent = (isAr ? 'قيّم: ' : 'Rate: ') + item.product_title;
      list.appendChild(link);
    });
    wrap.appendChild(list);
    this.messageEl.insertAdjacentElement('afterend', wrap);
  }

  renderEmailCapturePrompt(orderId) {
    const isAr = document.documentElement.getAttribute('dir') === 'rtl';
    const wrap = document.createElement('div');
    wrap.className = 'cod-cart-checkout__email-capture';
    const heading = document.createElement('p');
    heading.textContent = isAr
      ? 'أدخل بريدك الإلكتروني لتصلك رسالة تذكير لتقييم كتبك بعد استلامها:'
      : "Leave your email and we'll send you a reminder to review your books once they arrive:";
    wrap.appendChild(heading);
    const form = document.createElement('form');
    form.className = 'cod-cart-checkout__email-capture-form';
    const input = document.createElement('input');
    input.type = 'email';
    input.required = true;
    input.placeholder = isAr ? 'بريدك الإلكتروني' : 'Your email';
    form.appendChild(input);
    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.textContent = isAr ? 'إرسال' : 'Send';
    form.appendChild(submit);
    const feedback = document.createElement('p');
    feedback.className = 'cod-cart-checkout__email-capture-feedback';
    feedback.hidden = true;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      submit.disabled = true;
      try {
        const response = await fetch(`${this.getFunctionsUrl()}/save-order-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', apikey: this.dataset.supabaseAnonKey, Authorization: `Bearer ${this.dataset.supabaseAnonKey}` },
          body: JSON.stringify({ order_id: orderId, email: input.value.trim() }),
        });
        if (!response.ok) throw new Error('save_failed');
        form.hidden = true;
        feedback.textContent = isAr ? 'شكراً! سنراسلك قريباً.' : "Thanks! We'll be in touch.";
        feedback.hidden = false;
      } catch (error) {
        submit.disabled = false;
        feedback.textContent = isAr ? 'حدث خطأ، حاول مرة أخرى.' : 'Something went wrong, please try again.';
        feedback.hidden = false;
      }
    });
    wrap.appendChild(form);
    wrap.appendChild(feedback);
    this.messageEl.insertAdjacentElement('afterend', wrap);
  }
}

function normalizeAlgerianPhone(rawValue) {
  let digits = (rawValue || '').replace(/[^\d+]/g, '');
  if (digits.startsWith('+213')) digits = `0${digits.slice(4)}`;
  else if (digits.startsWith('213')) digits = `0${digits.slice(3)}`;
  return /^0[5-7]\d{8}$/.test(digits) ? digits : null;
}

customElements.define('cod-cart-checkout', CodCartCheckout);
